import PropTypes from 'prop-types'

const intlPropTypes = {
  formatMessage: PropTypes.func,
  locale: PropTypes.string
}

export default intlPropTypes
